import { t } from "@/i18n-js/instance";
import { CoursesLandingPage } from "@circle-react/components/Courses/CoursesLandingPage";
import { CourseFilters } from "@circle-react/components/Courses/Directory/Header/CourseFilters";
import { ListCoursesComponent } from "@circle-react/components/Courses/ListCourses";
import { PageMetaData } from "@circle-react/components/Layout/PageMetaData";
import { StandardLayout } from "@circle-react/components/Layout/StandardLayout";
import { StandardLayoutHeaderWithPortal } from "@circle-react/components/Layout/StandardLayoutV2/StandardLayoutHeader/StandardLayoutHeaderWithPortal";
import { SpaceHeaderTitleText } from "@circle-react/components/Spaces/Header/SpaceHeaderTitle/SpaceHeaderTitleText";
import { TopicFilters } from "@circle-react/components/Spaces/TopicFilters";
import { useFilters } from "@circle-react/components/Spaces/TopicFilters/hooks/useFilters";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { useNavigationLinks } from "@circle-react-uikit/HeaderV3/NavigationBar/hooks/useNavigationLinks";
import { CreateCourseButton } from "../CoursesLandingPage/CreateCourseButton";
import { Banner } from "./Banner";
import { ManageCoursesListActionsV3 } from "./Header/ManageCoursesListActionsV3";
import { useCoursesInfiniteQuery } from "./useCoursesInfiniteQuery";

export const ListCourses = () => {
  const { currentCommunityMember: member } = usePunditUserContext();

  const {
    courses,
    fetchNextPage,
    hasNextPage,
    isLoading,
    filter,
    handleFilterClick,
  } = useCoursesInfiniteQuery();

  const isAdmin = isCommunityAdmin(member);
  const { currentFilters } = useFilters();
  const { courseLink } = useNavigationLinks();
  const hasMember = Boolean(member);

  const coursePageTitle = courseLink?.label || t("courses.directory.title");

  if (
    isAdmin &&
    !isLoading &&
    Array.isArray(courses) &&
    courses.length === 0 &&
    !currentFilters.size
  ) {
    return <CoursesLandingPage />;
  }

  return (
    <>
      <StandardLayoutHeaderWithPortal
        leftContent={
          <SpaceHeaderTitleText>{coursePageTitle}</SpaceHeaderTitleText>
        }
        rightContent={
          <div className="flex items-center gap-4">
            <CreateCourseButton />
            {isAdmin && <ManageCoursesListActionsV3 />}
          </div>
        }
      />
      {hasMember && (
        <CourseFilters onClickHandler={handleFilterClick} filter={filter} />
      )}
      <StandardLayout.Body hasPaddingTopMobile={false}>
        <PageMetaData
          title={coursePageTitle}
          bodyClassNames="view-courses-directory"
        />
        <StandardLayout.Content className="!max-w-7xl md:!min-w-0">
          <Banner />
          <div className="mb-5">
            <TopicFilters isCourseDirectory />
          </div>
          <ListCoursesComponent
            communityMember={member}
            courses={courses}
            isLoading={isLoading}
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            filter={filter}
          />
        </StandardLayout.Content>
      </StandardLayout.Body>
    </>
  );
};

export default ListCourses;
